import { motion } from "framer-motion";
import { Spinner as Spin } from "react-bootstrap";

import classes from "./Spinner.module.css";

const Spinner = () => {
  return (
    <motion.div
      className={classes.backdrop}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.18 }}
    >
      <motion.div
        initial={{ scale: 0.92, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 400, damping: 28 }}
      >
        <Spin
          animation="border"
          size="lg"
          variant="primary"
          style={{ width: "6rem", height: "6rem" }}
          className={classes.spinner}
        />
      </motion.div>
    </motion.div>
  );
};

export default Spinner;
